export default __webpack_public_path__ + "static/0g_desktop-90becb138653496e9d18007e4b8757fa.jpg";